/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForSnowflake extends models.ServiceAccountNativeDetailsBaseForSaasDataServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForSnowflake");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForSnowflake.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForSnowflake>): ServiceAccountNativeDetailsForSnowflake {
        let obj = Object.assign(new ServiceAccountNativeDetailsForSnowflake(), model);
        ServiceAccountNativeDetailsForSnowflake.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForSnowflake>): ServiceAccountNativeDetailsForSnowflake {
        if (!model) return null;
        return ServiceAccountNativeDetailsForSnowflake.newInstance(<ServiceAccountNativeDetailsForSnowflake> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForSnowflake) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForSnowflake.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForSnowflake): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasDataServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForSnowflake.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
